module.exports = __webpack_public_path__ + "01ea978f/img/product-icon-grey.b248963c.svg";